import React from 'react'
import useSetPageName from 'src/Libs/navigation/hooks/use-set-page-name'
import { EXTERNAL_DOCUMENT_LINKS } from '../config'
import { DocumentSheetsPaper } from './DocumentSheets'

/**
 * Page for external document links.
 */
const DocumentLinksPage: React.FC = () => {
  useSetPageName('framework.document-links')

  return <DocumentSheetsPaper documentLinks={EXTERNAL_DOCUMENT_LINKS} />
}

export default DocumentLinksPage
